import {ServiceEventEntity} from "@ots-frontend/ots-data";
import {Card, Divider, Grid, Group, Text, Title} from "@mantine/core";
import {useTranslation} from "react-i18next";
import {FormattedDatabaseCode} from "../../text/FormattedDatabaseCode/FormattedDatabaseCode";
import {FormattedDateTime} from "../../date/FormattedDateTime/FormattedDateTime";
import {DefaultText} from "../../text/DefaultText/DefaultText";
import { EntityAnchor } from "../../anchor/EntityAnchor/EntityAnchor";

export type ServiceEventDetailsProps = {
  serviceEvent: ServiceEventEntity
}

export const ServiceEventDetails = (props: ServiceEventDetailsProps) => {
  const {serviceEvent} = props;

  const {t} = useTranslation(["common"]);

  return (
    <Grid>
      <Grid.Col span={12}>
        <Card shadow="sm" padding="lg" radius="md" withBorder>

          <Group position="apart" pb="sm">
            <Title order={4}>{t("profile.serviceevent.info.section.details.label", "Details")}</Title>
          </Group>

          <Divider/>

          <Grid>
            <Grid.Col span={12}>
              <Text ta="left" fz="sm" weight={500} mt="md">
                {t("profile.serviceevent.info.field.name.label", "Name")}
              </Text>
              <Text ta="left" c="dimmed" fz="xs">
                {serviceEvent.name}
              </Text>
            </Grid.Col>
            <Grid.Col span={6}>
              <Text ta="left" fz="sm" weight={500} mt="md">
                {t("profile.serviceevent.info.field.type.label", "Event Type")}
              </Text>
              <Text ta="left" c="dimmed" fz="xs">
                <FormattedDatabaseCode value={serviceEvent.eventType}/>
              </Text>
            </Grid.Col>
            <Grid.Col span={6}>
              <Text ta="left" fz="sm" weight={500} mt="md">
                {t("profile.serviceevent.info.field.company.label", "Company")}
              </Text>
              <Text ta="left" c="dimmed" fz="xs">
                <EntityAnchor value={{
                  objectId: serviceEvent.companyId,
                  objectType: "COMPANY",
                  objectName: serviceEvent.companyName
                }}/>
              </Text>
            </Grid.Col>
            <Grid.Col span={6}>
              <Text ta="left" fz="sm" weight={500} mt="md">
                {t("profile.serviceevent.info.field.start.label", "Start")}
              </Text>
              <Text ta="left" c="dimmed" fz="xs">
                <FormattedDateTime date={serviceEvent.startDttm}/>
              </Text>
            </Grid.Col>
            <Grid.Col span={6}>
              <Text ta="left" fz="sm" weight={500} mt="md">
                {t("profile.serviceevent.info.field.end.label", "End")}
              </Text>
              <Text ta="left" c="dimmed" fz="xs">
                <FormattedDateTime date={serviceEvent.endDttm}/>
              </Text>
            </Grid.Col>
            <Grid.Col span={6}>
              <Text ta="left" fz="sm" weight={500} mt="md">
                {t("profile.serviceevent.info.field.severity.label", "Severity Level")}
              </Text>
              <Text ta="left" c="dimmed" fz="xs">
                <DefaultText value={serviceEvent.severityLevel} defaultValue={"N/A"}/>
              </Text>
            </Grid.Col>
            <Grid.Col span={12}>
              <Text ta="left" fz="sm" weight={500} mt="md">
                {t("profile.serviceevent.info.field.notes.label", "Notes")}
              </Text>
              <Text ta="left" c="dimmed" fz="xs">
                <DefaultText value={serviceEvent.note} defaultValue={"N/A"}/>
              </Text>
            </Grid.Col>
            <Grid.Col span={12}>
              <Divider my="xs" variant="dotted"/>
            </Grid.Col>
            <Grid.Col span={6}>
              <Text ta="left" fz="sm" weight={500} mt="md">
                {t("profile.serviceevent.info.field.closeoutpolicy.label", "Closeout Policy")}
              </Text>
              <Text ta="left" c="dimmed" fz="xs">
                <FormattedDatabaseCode value={serviceEvent.closeoutPolicy}/>
              </Text>
            </Grid.Col>
            <Grid.Col span={6}>
              <Text ta="left" fz="sm" weight={500} mt="md">
                {t("profile.serviceevent.info.field.closeoutstatus.label", "Closeout Status")}
              </Text>
              <Text ta="left" c="dimmed" fz="xs">
                <FormattedDatabaseCode value={serviceEvent.closeoutStatus}/>
              </Text>
            </Grid.Col>
            {serviceEvent.closeoutDttm &&
              <Grid.Col span={6}>
                <Text ta="left" fz="sm" weight={500} mt="md">
                  {t("profile.serviceevent.info.field.closeoutdttm.label", "Closeout Date")}
                </Text>
                <Text ta="left" c="dimmed" fz="xs">
                  <FormattedDateTime date={serviceEvent.closeoutDttm} />
                </Text>
              </Grid.Col>
            }
          </Grid>
        </Card>
      </Grid.Col>
    </Grid>
  );
};

